<template>
  <div v-show="show" class="dacb-reply-dots">
    <span class="dacb-reply-dots-container"
      ><!--
      --><span
      ></span
      ><!--
      --><span
      ></span
      ><!--
      --><span
      ></span>
    </span>
    <div class="dacb-reply-dots-text">{{ $t("typing") }}...</div>
  </div>
</template>

<script>
import bus from "helpers/bus";

export default {
  name: "ReplyDots",

  emits: ["toggled"],

  data() {
    return {
      show: false
    };
  },

  created() {
    bus.$on("replyDots:show", this.handleShow);
  },

  unmounted() {
    bus.$off("replyDots:show", this.handleShow);
  },

  methods: {
    handleShow(val) {
      if (this.show !== val) {
        this.show = val;
        this.$emit("toggled");
      }
    }
  }
};
</script>
